var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('app-header'),_c('main',[_c('h1',[_vm._v("Apply for a Free Public Good Account")]),_c('app-form')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }